import React, { createRef } from "react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import mainLogo from "./../_img/logo-csmile.png";
import { genURL, gengetURLTEST } from "./../_getjson";
import axios from "axios";
import Backdrop from "./../Components/CustomBackdrop/Barckdrop";
import Snackbar from "./../Components/Snackbar/Snackbar";
import ErrorIcon from "@mui/icons-material/ErrorOutlineRounded";
import SelectData from "./../PopUp/SelectData";
require("./../_css/PopUpOther.css");
//test
export default class PopUpItem extends React.Component {
  constructor(props) {
    super(props);
    this.SearchInput = createRef();
    this.stockType = createRef();
    this.stockType_code = createRef();

    this.state = {
      rows: [],
      checkLIKE: true,
      checkCODE: true,
      checkNAMESEARCH: false,
      checkNAMETH: true,
      checkOLDCODE: false,
      checkBARCODE: false,
      checkProductset: false,
      openBackdrop: false,
      stockType: "0",
      autoClose: 3600,
      color: "warning",
      messagealert: "",
    };
    this.onCheckChange = this.onCheckChange.bind(this);
  }
  onCheckChange(e) {
    switch (e.target.name) {
      case "checkLIKE":
        this.setState({ checkLIKE: e.target.checked });
        break;
      case "check1":
        this.setState({ check1: e.target.checked });
        break;
      case "checkProductset":
        this.setState({ checkProductset: e.target.checked });
        // if (e.target.checked === true) {

        // }
        break;
      case "checkCODE":
        this.setState({ checkCODE: e.target.checked });
        break;
      case "checkNAMETH":
        this.setState({ checkNAMETH: e.target.checked });
        break;
      case "checkNAMESEARCH":
        this.setState({ checkNAMESEARCH: e.target.checked });
        break;
      case "checkOLDCODE":
        this.setState({ checkOLDCODE: e.target.checked });
        break;
      case "checkBARCODE":
        this.setState({ checkBARCODE: e.target.checked });
        break;
      default:
        break;
    }
    setTimeout(() => {
      this.readData(
        this.SearchInput.current.value ? this.SearchInput.current.value : ""
      );
    }, 200);
  }
  componentDidMount() {
    this.loadData();
  }

  loadData = async function () {
    this.setState({ openBackdrop: true });
    let url = "CSPRODUCT/All?&top=500&user=" + localStorage.getItem("Username");
    let colproduct = [];
    await console.log(genURL(url));
    await axios
      .get(genURL(url), { timeout: 60000 })
      .then((res) => {
        console.log(res.data);
        if (res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            colproduct[i] = {
              number: i + 1,
              code: res.data[i].CODE,
              text: res.data[i].NAMETH,
              salelastprice: res.data[i].SALELASTPRICE,
              unitname: res.data[i].UNITNAME,
              STOCKQTY: res.data[i].STOCKQTY,
              STOCKQTYWH: res.data[i].STOCKQTYWH,
              NETSTOCK: res.data[i].NETSTOCK,
              GIWAREHOUSE: res.data[i].GRWAREHOUSE,
              LOCATION: res.data[i].GRLOCATION,
              maingroup: res.data[i].MAINGROUP,
              PRODUCTSET: res.data[i].PRODUCTSET,
            };
          }
        } else {
          this.setState({ opensnackbar: true });
          this.setState({ color: "warning" });
          this.setState({ icon: ErrorIcon });
          this.setState({ messagealert: "ไม่พบข้อมูล" });
          this.setState({ openBackdrop: false });
          return;
        }
      })
      .then(async (_) => {
        await this.setState({ rows: colproduct });
        this.setState({ openBackdrop: false });
      })
      .catch((error) => {
        this.setState({ openBackdrop: false });
        console.log("Error" + error);
      });
  };

  onKeyUp = (data) => {
    if (data.key === "Enter") {
      var value = data.target.value;
      this.readData(value);
    }
  };
  readData = (data) => {
    if (data !== "") {
      this.onWriteRow(data);
      /* this.setState({ CText2: "" }); */
    } else {
      this.onWriteRow("");
      /* this.setState({ CText2: "" }); */
    }
  };

  onClickSearch = () => {
    var value = this.SearchInput.current.value;
    this.readData(value);
  };
  onWriteRow = async function (data) {
    this.setState({ openBackdrop: true });
    var checkLIKE = this.state.checkLIKE;
    // var check1 = this.state.check1
    var checkProductset = this.state.checkProductset;
    var checkCODE = this.state.checkCODE;
    var checkNAMETH = this.state.checkNAMETH;
    var checkNAMESEARCH = this.state.checkNAMESEARCH;
    var checkNAMESEARCH = this.state.checkNAMESEARCH;
    var checkOLDCODE = this.state.checkOLDCODE;
    var checkBARCODE = this.state.checkBARCODE;
    // if (this.SearchInput.current.value === "") {
    //     checkLIKE = false
    //     // check1 = false
    //     checkProductset = false
    //     checkCODE = false
    //     checkNAMETH = false
    //     checkNAMESEARCH = false
    //     checkNAMESEARCH = false
    //     checkOLDCODE = false
    //     checkBARCODE = false
    // }
    var url = `CSPRODUCT/GETSearchproduct?checkLIMIT=300&user=${localStorage.getItem(
      "Username"
    )}&checkLIKE=${checkLIKE}&checkCODE=${checkCODE}&checkNAMETH=${checkNAMETH}&checkNAMESEARCH=${checkNAMESEARCH}&checkOLDCODE=${checkOLDCODE}&checkBARCODE=${checkBARCODE}&checkProductset=${checkProductset}&STOCKTYPE=${
      this.state.stockType
    }&txt=${data}`;
    let colproduct = [];
    console.log(genURL(url));
    await axios
      .get(genURL(url), { timeout: 60000 })
      .then((res) => {
        if (res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            colproduct[i] = {
              number: i + 1,
              code: res.data[i].CODE,
              text: res.data[i].NAMETH,
              salelastprice: res.data[i].SALELASTPRICE,
              unitname: res.data[i].UNITNAME,
              STOCKQTY: res.data[i].STOCKQTY,
              STOCKQTYWH: res.data[i].STOCKQTYWH,
              NETSTOCK: res.data[i].NETSTOCK,
              GIWAREHOUSE: res.data[i].GRWAREHOUSE,
              LOCATION: res.data[i].GRLOCATION,
              maingroup: res.data[i].MAINGROUP,
              PRODUCTSET: res.data[i].PRODUCTSET,
            };
          }
        } else {
          this.setState({ openBackdrop: false });
        }
      })
      .then(async (_) => {
        await this.setState({ rows: colproduct });
        // this.stockType_code.current.value = this.state.stockType
        this.setState({ openBackdrop: false });
      })
      .catch((error) => {
        console.log("Error" + error);
        this.setState({ openBackdrop: false });
      });
  };
  onSelectRow = (data) => {
    // if (Number(data.NETSTOCK) === 0 && data.maingroup !== "03" && data.PRODUCTSET !== 1 && this.props.from !== "CSPURCHASE" && this.props.from !== "CSPR"
    //     && this.props.from !== "CSSALERET" && this.props.from !== "CSSALERETREQ" && this.props.from !== "CSSTKISSUEREQ" && this.props.from !== "CSSTKMOVEREQ" && this.props.from !== "CSQUOT" && this.props.from !== "CSStkMoveReq") {
    //     this.setState({ opensnackbar: true })
    //     this.setState({ color: "warning" })
    //     this.setState({ icon: ErrorIcon })
    //     this.setState({ messagealert: "สินค้าไม่พอขาย" })
    //     return
    // } else {
    this.props.Get_PopUpItem(data.code, data, this.state.stockType);
    this.props.closePopup();
    // }
  };
  SelectSetData = (provenance, data) => {
    switch (provenance) {
      case "ProductType":
        this.setState({ stockType: data });
        setTimeout(() => {
          this.readData(
            this.SearchInput.current.value ? this.SearchInput.current.value : ""
          );
        }, 100);
        break;
      default:
        break;
    }
    // this.setState({ stockType: data2 })
    // this.stockType_code.current.value = checkInput(data1, data2)
    // this.stockType.current.value = checkInput(data1, data2)
    // setTimeout(() => {
    //     var value = this.SearchInput.current.value;
    //     this.readData(value)
    // }, 100);
  };
  render() {
    return (
      <div className="popup">
        <Backdrop open={this.state.openBackdrop} />
        <div className="popup_inner">
          <div className="PopUpOtherDivH" align="left">
            <div className="PopUpOtherDivH1">
              {" "}
              <i className="fas fa-search"> ค้นหาสินค้า </i>{" "}
            </div>
            <div className="PopUpOtherDivH2" onClick={this.props.closePopup}>
              <i className="fas fa-times"></i>
            </div>
          </div>
          <div className="panel-body divTable" align="right">
            <div className="col-md-2">
              <img src={mainLogo} width="100" />
            </div>
            <div
              className="col-md-8"
              align="left" /* style={{ marginBottom: "10px" }} */
            >
              <br></br>
              <div className="input-group width-grop1">
                <span className="input-group-addon txt-img icon">
                  {" "}
                  <b>&nbsp;&nbsp;คำค้นหา&nbsp;&nbsp;</b>
                </span>
                <input
                  type="text"
                  className="form-control"
                  placeholder="กรอกคำค้นหา เช่น รหัสสินค้า,ชื่อสินค้า"
                  ref={this.SearchInput}
                  onKeyUp={this.onKeyUp}
                />
                <span className="input-group-addon txt-img icon">
                  <i className="fas fa-search" onClick={this.onClickSearch}></i>
                </span>
                <span className="input-group-addon txt-img icon">
                  {" "}
                  <i
                    className="fas fa-sync-alt"
                    onClick={this.onClickSearch}
                  ></i>
                </span>
              </div>
              <div className="DivTable" style={{ marginBottom: "10px" }}>
                <input
                  type="checkbox"
                  name="checkLIKE"
                  onChange={this.onCheckChange}
                  checked={this.state.checkLIKE}
                ></input>
                <span className="choiceSty">ค้นแบบส่วนใดส่วนหนึ่ง &nbsp;</span>
                <input
                  type="checkbox"
                  name="checkCODE"
                  onChange={this.onCheckChange}
                  checked={this.state.checkCODE}
                />
                <span className="choiceSty">ค้นจากรหัส &nbsp;</span>
                <input
                  type="checkbox"
                  name="checkNAMETH"
                  onChange={this.onCheckChange}
                  checked={this.state.checkNAMETH}
                />
                <span className="choiceSty">ค้นจากชื่อ/คำอธิบาย &nbsp;</span>
                <input
                  type="checkbox"
                  name="checkNAMESEARCH"
                  onChange={this.onCheckChange}
                ></input>
                <span className="choiceSty">ค้นจากชื่อค้นหา &nbsp;</span>
                <input
                  type="checkbox"
                  name="checkOLDCODE"
                  onChange={this.onCheckChange}
                ></input>
                <span className="choiceSty">ค้นจากรหัสเก่า &nbsp; </span>
                <input
                  type="checkbox"
                  name="checkBARCODE"
                  onChange={this.onCheckChange}
                ></input>
                <span className="choiceSty">ค้นจากบาร์โค้ด &nbsp;</span>
                <input
                  type="checkbox"
                  name="checkProductset"
                  onChange={this.onCheckChange}
                ></input>
                <span className="choiceSty">เฉพาะสินค้าชุด &nbsp;</span>
              </div>
              <div className="input-group width-grop1">
                <SelectData
                  origin="ProductType" // ประเภทสินค้า
                  valueSelect={(e) => this.SelectSetData("ProductType", e)} // รับค่ากลับ
                  title="ประเภทสินค้า :"
                  defaultselect={this.state.stockType} // ค่าเริ่มต้นของ
                  popup={true}
                />
              </div>
            </div>
            <BootstrapTable
              data={this.state.rows}
              options={{
                onRowClick: this.onSelectRow,
                withoutNoDataText: true,
              }}
              height="650"
              tableBodyClass="my-custom-class"
              hover
              condensed
            >
              <TableHeaderColumn
                columnClassName="columnAll columnID"
                className="columnNumber"
                dataAlign="center"
                width="50"
                dataField="number"
                isKey
              >
                {" "}
              </TableHeaderColumn>
              <TableHeaderColumn
                columnClassName="columnAll"
                className="columnNumber"
                width="150"
                dataField="code"
                dataSort
                columnTitle
              >
                {" "}
                รหัส{" "}
              </TableHeaderColumn>
              <TableHeaderColumn
                columnClassName="columnAll"
                className="columnNumber"
                width="400"
                tdStyle={{ whiteSpace: "normal", wordWrap: "break-word" }}
                dataField="text"
                dataSort
                columnTitle
              >
                {" "}
                ชื่อ/คำอธิบาย{" "}
              </TableHeaderColumn>
              {/* <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="center" width="10%" dataField='GIWAREHOUSE' dataSort> คลัง </TableHeaderColumn> */}
              {/* <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="center" width="10%" dataField='LOCATION' dataSort> ที่เก็บ </TableHeaderColumn> */}
              <TableHeaderColumn
                columnClassName="columnAll"
                className="columnNumber"
                dataAlign="right"
                width="150"
                dataField="STOCKQTY"
                dataSort
              >
                {" "}
                คงเหลือรวม{" "}
              </TableHeaderColumn>
              <TableHeaderColumn
                columnClassName="columnAll"
                className="columnNumber"
                dataAlign="right"
                width="10%"
                dataField="NETSTOCK"
                dataSort
              >
                {" "}
                สุทธิ{" "}
              </TableHeaderColumn>
              <TableHeaderColumn
                columnClassName="columnAll"
                className="columnNumber"
                dataAlign="right"
                width="10%"
                dataField="STOCKQTYWH"
              >
                {" "}
                คลังจ่าย{" "}
              </TableHeaderColumn>
              <TableHeaderColumn
                columnClassName="columnAll"
                className="columnNumber"
                dataAlign="right"
                width="150"
                dataField="salelastprice"
                dataSort
              >
                {" "}
                ราคาขายล่าสุด{" "}
              </TableHeaderColumn>
              <TableHeaderColumn
                columnClassName="columnAll"
                className="columnNumber"
                dataAlign="center"
                width="100"
                dataField="unitname"
                dataSort
              >
                {" "}
                หน่วย{" "}
              </TableHeaderColumn>
              <TableHeaderColumn rowSpan="2" dataField="PRODUCTSET" hidden>
                {" "}
                PRODUCTSET{" "}
              </TableHeaderColumn>
            </BootstrapTable>
          </div>
        </div>
        <Snackbar
          place="br"
          color={this.state.color}
          icon={this.state.icon}
          autoClose={this.state.autoClose}
          message={this.state.messagealert}
          open={this.state.opensnackbar}
          closeNotification={() => {
            this.setState({ opensnackbar: false });
          }}
          close
        />
      </div>
    );
  }
}

export class PopUpCSEXPENSE extends React.Component {
  constructor(props) {
    super(props);
    this.Search = React.createRef();
    this.state = {
      rows: [],
      autoClose: 3600,
      color: "warning",
      messagealert: "",
    };
  }
  componentDidMount() {
    this.onWriteRow("0");
  }
  onWriteRow = (data) => {
    var url = "CSOTHEREXPENSE/Searchexpense?Code=" + data;
    console.log(genURL(url));
    axios.get(genURL(url)).then((res) => {
      /* var Url = "http://Localhost:8080/Csexpense?Code=" + data;
            INSCorServicePostTest(Url).then(res => { */
      if (res.data === undefined) {
        return;
      }
      var data = res.data;
      let col = [];
      for (var i = 0; i <= data.length - 1; i++) {
        col[i] = {
          number: i + 1,
          code: data[i].CODE,
          text: data[i].MYNAMETH,
          salelastprice: data[i].SALELASTPRICE,
          unitname: data[i].STOCKUNIT,
          STOCKQTY: data[i].STOCKQTY,
          STOCKQTYWH: data[i].STOCKQTYWH,
          NETSTOCK: data[i].NETSTOCK,
          GIWAREHOUSE: data[i].GIWAREHOUSE,
        };
      }
      this.setState({ rows: col });
    });
  };
  Get_Expcode = (e) => {
    if (e.key === "Enter") {
      this.onWriteRow(e.target.value);
    }
    if (e === "Click") {
      this.onWriteRow(this.Search.current.value);
    }
  };
  onSelectRow = (data) => {
    if (data.code) {
      this.props.Get_PopUpCSEXPENSE(data);
      this.props.closePopup();
    } else {
      // this.setState({ opensnackbar: true })
      // this.setState({ color: "warning" })
      // this.setState({ icon: ErrorIcon })
      // this.setState({ messagealert: "ไม่พบข้อมูล" })
    }
  };
  render() {
    return (
      <div className="popup">
        <div className="popup_inner">
          {this.props.Data}
          <div className="PopUpOtherDivH" align="left">
            <div className="PopUpOtherDivH1">
              <i className="fas fa-search"> ค้นหารรายได้อื่นๆ-Expense </i>
            </div>
            <div className="PopUpOtherDivH2">
              <i className="fas fa-times" onClick={this.props.closePopup}></i>
            </div>
          </div>
          <div className="panel-body divTable" align="left">
            <div className="input-group width-grop">
              <input
                id="id1"
                type="text"
                className="form-control"
                ref={this.Search}
                onKeyPress={this.Get_Expcode.bind(null)}
              />
              <span
                id="iconsearch"
                className="input-group-addon icon"
                onClick={this.Get_Expcode.bind(null, "Click")}
              >
                <i className="fas fa-search"></i>
              </span>
            </div>
            <div className="DivTable">
              <BootstrapTable
                data={this.state.rows}
                options={{
                  onRowClick: this.onSelectRow,
                  noDataText: "ไม่พบข้อมูลที่ค้นหา",
                }}
                height="750"
                hover
                condensed
              >
                <TableHeaderColumn
                  columnClassName="columnAll columnID"
                  className="columnNumber"
                  dataAlign="center"
                  width="35"
                  dataField="number"
                  isKey
                >
                  {" "}
                </TableHeaderColumn>
                <TableHeaderColumn
                  columnClassName="columnAll"
                  className="columnNumber"
                  width="150"
                  dataField="code"
                >
                  {" "}
                  รหัส{" "}
                </TableHeaderColumn>
                <TableHeaderColumn
                  columnClassName="columnAll"
                  className="columnNumber"
                  dataField="text"
                >
                  {" "}
                  ชื่อ/คำอธิบาย{" "}
                </TableHeaderColumn>
              </BootstrapTable>
            </div>
          </div>
        </div>
        <Snackbar
          place="br"
          color={this.state.color}
          icon={this.state.icon}
          autoClose={this.state.autoClose}
          message={this.state.messagealert}
          open={this.state.opensnackbar}
          closeNotification={() => {
            this.setState({ opensnackbar: false });
          }}
          close
        />
      </div>
    );
  }
}
